/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Search = ({
    SearchValue,
    handleOnClickSearch,
    optimizedFn,
    customSearchBarWidth,
    customSearchPlaceHolder,

}) => {

    const locate = useLocation()
    const [searchValue1, setSearchValue] = useState(SearchValue);
    const [isClearVisible, setClearVisible] = useState(false);

    useEffect(() => {
        setClearVisible(searchValue1.length > 0);
    }, [locate])


    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            performSearch(e, searchValue1);
        }
    };

    const clearAndperformSearch = (e) => {
        e.target.value = '';
        setSearchValue(e.target.value);
        performSearch(e, '');
    }

    const performSearch = (e, searchVal) => {
        searchVal = searchVal == undefined ? searchValue1 : searchVal;
        if (optimizedFn === undefined) {
            handleOnClickSearch('search', searchVal);
        } else {
            handleOnClickSearch(searchVal);
            optimizedFn !== undefined && optimizedFn('search', searchVal);
        }
    };

    return (
        <div className="relative search-tab">
            <label htmlFor="input"></label>
            <div className="top-[52%] -translate-y-[50%]" id='search_button' style={{ 'top': '0px' }}>
                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img"/>
            </div>
            <div class="relative flex">
                <input
                    maxLength={90}
                    type="text"
                    id="search-value"
                    autoComplete='off'
                    value={searchValue1}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    placeholder={customSearchPlaceHolder}
                />
            </div>
            {isClearVisible && <div className='absolute cross_icon' id='clear_icon' onClick={clearAndperformSearch} title='Clear Seach'> </div>}

        </div>
    )
}

export default Search;